export function convertHSLColorToCssString(color) {
  const [h, s, l, a] = color;
  const saturation = Number(s) * 100;
  const lightness = Number(l) * 100;

  return `hsl(${h} ${saturation}% ${lightness}% / ${a})`;
}
